import { useAppSelector } from "app/store";
import { createSchemaAwareLabel } from "utils/schemaUtils";
import { useMemo } from "react";

/**
 * Hook that provides a function to create schema-aware labels for audit forms
 */
export const useAuditSchemaAwareLabels = () => {
  const auditFormSchema = useAppSelector(
    (state) => state.teamSettings.auditSchemas.auditFormSchema,
  );

  return useMemo(() => {
    return (baseLabel: string, fieldName: string) =>
      createSchemaAwareLabel(baseLabel, fieldName, auditFormSchema);
  }, [auditFormSchema]);
};
